import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import AuthShell from "@/components/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(null);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email, origin: window.location.origin });
      setSent(data);
    } catch (e) {
      setErr(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Erreur");
    } finally {
      setSubmitting(false);
    }
  };

  if (sent) {
    return (
      <AuthShell eyebrow="Mot de passe oublié" title="Vérifiez votre boîte mail.">
        <div className="rounded-3xl border border-[#E6C29A] bg-gradient-to-br from-[#FAF3EA] to-white p-6 text-center" data-testid="forgot-sent">
          <div className="w-12 h-12 rounded-full bg-[#1A1A1A] flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="w-6 h-6 text-[#D4A574]" />
          </div>
          <p className="text-sm text-[#1A1A1A]">{sent.message}</p>
          {sent.dev_reset_link && (
            <div className="mt-4 p-3 bg-white rounded-xl border border-[#EADDC9] text-left">
              <p className="caption-label text-[#A26F3E] mb-1">Mode DEV — Lien direct</p>
              <a href={sent.dev_reset_link} className="text-xs text-[#1A1A1A] break-all underline" data-testid="forgot-dev-link">
                {sent.dev_reset_link}
              </a>
            </div>
          )}
          <Link to="/login">
            <Button className="mt-5 w-full rounded-full bg-[#C68E59] hover:bg-[#A26F3E] text-white h-12">Retour à la connexion</Button>
          </Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell eyebrow="Mot de passe oublié" title="Réinitialisez votre mot de passe." subtitle="Entrez votre adresse email — nous vous envoyons un lien sécurisé.">
      <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
        <div>
          <Label className="caption-label">Email</Label>
          <div className="relative mt-2">
            <Mail className="w-4 h-4 text-[#A26F3E] absolute left-3.5 top-1/2 -translate-y-1/2" />
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="vous@email.com" className="rounded-xl pl-10 h-11" data-testid="forgot-email" />
          </div>
        </div>
        {err && (
          <div className="rounded-xl bg-[#FEEFEC] border border-[#F2C0B7] text-[#A3483F] text-sm px-4 py-3">{err}</div>
        )}
        <Button type="submit" disabled={submitting} className="w-full rounded-full bg-[#C68E59] hover:bg-[#A26F3E] text-white h-12" data-testid="forgot-submit">
          {submitting ? (<><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Envoi…</>) : "Envoyer le lien"}
        </Button>
      </form>
      <p className="text-sm text-[#6E4B2A] text-center mt-6">
        <Link to="/login" className="font-semibold text-[#1A1A1A] underline">Retour à la connexion</Link>
      </p>
    </AuthShell>
  );
}
